import { render } from "./impajust2.vue?vue&type=template&id=6358cc14"
import script from "./impajust2.vue?vue&type=script&lang=js"
export * from "./impajust2.vue?vue&type=script&lang=js"

import "./impajust2.vue?vue&type=style&index=0&id=6358cc14&lang=css"

import exportComponent from "D:\\work\\work\\project\\intelegent\\ips\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__